// extracted by css-extract-rspack-plugin
export default {"illustrationLandscape":"illustrationLandscape-X8kWcD","illustrationPortrait":"illustrationPortrait-uWek80"};